import { Link } from 'react-router-dom';
import { siteNavLinks, aboutInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4 group">
              <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-50 tracking-wider group-hover:text-primary-400 transition-colors">
                黑料718
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-sm mb-6">
              全网吃瓜，只在718。国内领先的娱乐资讯聚合平台，为您提供最新、最全、最真实的娱乐八卦和网红黑料。
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 hover:text-primary-400 hover:bg-background-300 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-100 text-sm font-semibold mb-5">
              <a href="/category/wanghong-tafang" className="hover:text-primary-400 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-3">
              {siteNavLinks.footer.categories.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 text-sm font-semibold mb-5">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-3">
              {siteNavLinks.footer.about.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-100 text-sm font-semibold mb-5">
              <a href="/about" className="hover:text-primary-400 transition-colors">帮助支持</a>
            </h4>
            <ul className="space-y-3">
              {siteNavLinks.footer.support.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 黑料718. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-3 sm:mt-0">
            <Link to="/about" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors">隐私政策</Link>
            <Link to="/about" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors">服务条款</Link>
            <Link to="/about" className="text-foreground-600 hover:text-foreground-400 text-xs transition-colors">免责声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}